import React, { useContext } from 'react';
import './Item.css';
import { ShopContext } from '../../Context/ShopContext';
import { FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';

const Item = (props) => {
    const { addToCart, shopStatus } = useContext(ShopContext);
    const isShopOpen = shopStatus.isShopCurrentlyOpen;

    if (!props.data) { return null; }
    const { _id, name, imageUrl, price } = props.data;

    const handleAddToCart = () => {
        // The context's addToCart function handles the "shop closed" toast.
        addToCart(_id); 
        
        if (isShopOpen) {
            toast.success(`${name} added to cart!`);
        }
    };

    return (
        <div className={`item-card ${!isShopOpen ? 'item-card-disabled' : ''}`}>
            <div className="item-card-image-wrapper">
                <img src={imageUrl} alt={name} className="item-card-image" />
                {!isShopOpen && <div className="item-card-closed-overlay">Closed</div>}
            </div>
            <div className="item-card-details">
                <h3 className="item-card-name">{name}</h3>
                <div className="item-card-footer">
                    <p className="item-card-price">₹{price}</p>
                    <button 
                        className="item-card-add-btn" 
                        onClick={handleAddToCart}
                        disabled={!isShopOpen} 
                    >
                        <FiPlus size={20} />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Item;